import { handleActions } from 'redux-actions';
import {
  App,
  appSettingsFetchFailed,
  appSettingsFetchInitialized,
  appSettingsFetchSucceeded,
  appSettingsUpdateSucceeded,
} from '@piwikpro/apps-crate';

const inUnderAppDetailsRoute = new RegExp('/apps/(.*)');

export interface AppSettingsState {
  isLoading: boolean
  settings: App | null
  failed: boolean
}

const initialState: AppSettingsState = {
  isLoading: true,
  settings: null,
  failed: false,
};

interface RouterPayload {
  location: {
    pathname: string
  }
}

type AppSettingsPayload = App & RouterPayload;

const reducer = handleActions<AppSettingsState, AppSettingsPayload>({
  [appSettingsFetchInitialized.toString()]: () => initialState,
  [appSettingsFetchSucceeded.toString()]: (state, { payload }) => ({
    ...state,
    isLoading: false,
    settings: payload,
  }),
  [appSettingsFetchFailed.toString()]: state => ({
    ...state,
    failed: true,
    isLoading: false,
  }),
  [appSettingsUpdateSucceeded.toString()]: (state, { payload }) => ({
    ...state,
    settings: {
      ...state.settings!,
      attributes: {
        ...state.settings!.attributes,
        ...payload,
      },
    },
  }),
  '@@router/LOCATION_CHANGE': (state, { payload }) => {
    if (!inUnderAppDetailsRoute.test(payload.location.pathname)) {
      return initialState;
    }

    return {
      ...state,
    };
  },
}, initialState);

export default reducer;
